"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _ButtonDraggable = _interopRequireDefault(require("../NavToolbar/ButtonDraggable"));

var _ButtonCollapsible = _interopRequireDefault(require("../NavToolbar/ButtonCollapsible"));

var _ButtonSelectable = _interopRequireDefault(require("../NavToolbar/ButtonSelectable"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  icon: {
    margin: theme.spacing(1.5)
  }
}));

const ModuleIconButton = ({
  className,
  icon,
  onClick,
  collapsible,
  expanded,
  onToggle,
  selectable,
  selected,
  onSelect,
  sortBadge,
  draggable,
  draggableHandle
}) => {
  const classes = useStyles();

  if (selectable) {
    return _react.default.createElement("div", {
      className: className || classes.root
    }, selectable && _react.default.createElement(_ButtonSelectable.default, {
      selected: selected,
      onClick: onSelect
    }));
  }

  if (draggable && draggableHandle) {
    return _react.default.createElement("div", {
      className: className || classes.root
    }, draggable && _react.default.createElement(_ButtonDraggable.default, {
      icon: icon,
      sortBadge: sortBadge,
      draggableHandle: draggableHandle
    }));
  }

  if (collapsible) {
    return _react.default.createElement("div", {
      className: className || classes.root
    }, collapsible && _react.default.createElement(_ButtonCollapsible.default, {
      expanded: expanded,
      onClick: onToggle
    }));
  }

  if (icon && onClick) {
    return _react.default.createElement(_IconButton.default, {
      className: className || classes.root,
      onClick: onClick
    }, _react.default.createElement(_Icon.default, null, icon));
  }

  if (icon) {
    return _react.default.createElement("div", {
      className: className || classes.root
    }, _react.default.createElement(_Icon.default, {
      className: classes.icon
    }, icon));
  }

  return false;
};

ModuleIconButton.propTypes = process.env.NODE_ENV !== "production" ? {
  draggable: _propTypes.default.bool,
  draggableHandle: _propTypes.default.bool,
  selectable: _propTypes.default.bool,
  selected: _propTypes.default.bool,
  onSelect: _propTypes.default.func,
  collapsible: _propTypes.default.bool,
  expanded: _propTypes.default.bool,
  onToggle: _propTypes.default.func
} : {};
var _default = ModuleIconButton;
exports.default = _default;
module.exports = exports.default;